export var SexoEnum;
(function (SexoEnum) {
    SexoEnum["MASCULINO"] = "MASCULINO";
    SexoEnum["FEMININO"] = "FEMININO";
})(SexoEnum || (SexoEnum = {}));
(function (SexoEnum) {
    var mapDescricao = new Map([
        [SexoEnum.MASCULINO, "Masculino"],
        [SexoEnum.FEMININO, "Feminino"],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    SexoEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    SexoEnum.getOptions = getOptions;
})(SexoEnum || (SexoEnum = {}));
